@if (showFallback()) {
  <main class="landing-fallback">
    <p>FAC3LESS Platinum Card</p>
    <a [href]="target">Open fac3less.com</a>
    <a href="/login">Login</a>
  </main>
}
